import { defineAction } from '@cheesecakelabs/boilerplate/utils'

import * as nonTaskService from '_services/non-tasks'

export const CREATE_NON_TASK = defineAction('CREATE_NON_TASK')
export const GET_NON_TASKS = defineAction('GET_NON_TASKS')
export const UPDATE_NON_TASK = defineAction('UPDATE_NON_TASK')
export const DELETE_NON_TASK = defineAction('DELETE_NON_TASK')

export const createNonTask = payload => (dispatch, getState) =>
  dispatch({
    type: CREATE_NON_TASK.ACTION,
    payload: nonTaskService
      .createNonTask(getState().user.get('token'))(payload)
      .then(() => nonTaskService.getNonTasks(getState().user.get('token'))()),
  })

export const getNonTasks = () => (dispatch, getState) =>
  dispatch({
    type: GET_NON_TASKS.ACTION,
    payload: nonTaskService.getNonTasks(getState().user.get('token')),
  })

export const updateNonTask = (id, payload) => (dispatch, getState) =>
  dispatch({
    type: UPDATE_NON_TASK.ACTION,
    payload: nonTaskService
      .updateNonTask(getState().user.get('token'))(id, payload)
      .then(() => nonTaskService.getNonTasks(getState().user.get('token'))()),
  })

export const deleteNonTask = id => (dispatch, getState) =>
  dispatch({
    type: DELETE_NON_TASK.ACTION,
    payload: nonTaskService
      .deleteNonTask(getState().user.get('token'))(id)
      .then(() => id),
  })



// WEBPACK FOOTER //
// ./src/modules/non-task/actions.js